export const getFileAsImage = (f: File) =>
  new Promise<HTMLImageElement>((res, rej) => {
    const _URL = window.URL || window.webkitURL;
    const img = new Image();
    var objectUrl = _URL.createObjectURL(f);
    img.onload = function () {
      res(img);
      _URL.revokeObjectURL(objectUrl);
    };
    img.onerror = rej;
    img.src = objectUrl;
  });

export const downloadFileFromURL = async (url: string, filename: string) => {
  const linkElement = document.createElement("a");
  linkElement.setAttribute("href", url);
  linkElement.setAttribute("download", filename);
  linkElement.setAttribute("target", "_blank");
  linkElement.click();
};
